import { FC } from "react";
import {
    IonCard,
    IonCardContent,
    IonContent,
    IonIcon,
    IonItem,
    IonList,
    IonPage,
    IonText,
} from "@ionic/react";
import { HeaderComponent } from "../../../../components";
import { useTranslation } from "react-i18next";
import { checkmarkCircleOutline, openOutline } from "ionicons/icons";
import { useSubscription } from "../../../../components/hooks";
import refsixSquareLogo from "../../../../assets/images/icon/refsix-square-icon.png";
import refAssistLogo from "../../../../assets/images/icon/refassist-logo-small.png";

const RefAssistIntegration: FC = () => {
    const { t } = useTranslation();

    const subscriptionState = useSubscription();

    const refAssistSubs = subscriptionState?.subscriptions?.filter((sub) => {
        return sub.provider === "refassist";
    });

    return (
        <IonPage>
            <HeaderComponent
                showBackButton
                defaultHref={"/"}
                title="RefAssist"
                titleTestId="refassist-integrations-page-header"
            />
            <IonContent>
                <IonCard color="transparent">
                    <IonCardContent>
                        {!refAssistSubs || refAssistSubs.length === 0 ? (
                            <>
                                <div
                                    style={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        display: "flex",
                                        paddingTop: "36px",
                                        paddingBottom: "21px",
                                    }}
                                >
                                    <img
                                        style={{ width: "64px" }}
                                        src={refsixSquareLogo}
                                        alt={"refsix logo"}
                                    />
                                    <IonText
                                        style={{
                                            margin: "0 20px",
                                            fontSize: "30px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        +
                                    </IonText>
                                    <img
                                        style={{
                                            width: 64,
                                            borderRadius: 12,
                                        }}
                                        src={refAssistLogo}
                                        alt={"refassist logo"}
                                    />
                                </div>
                                <p>
                                    <IonText>
                                        {t(
                                            "integrations.refAssist.description"
                                        )}
                                    </IonText>
                                </p>

                                <p style={{ marginTop: 10 }}>
                                    <IonText>
                                        {t(
                                            "integrations.refAssist.askYourLeague"
                                        )}
                                    </IonText>
                                </p>

                                <p style={{ marginTop: 10 }}>
                                    <IonText>
                                        {t("integrations.refAssist.email")}
                                    </IonText>
                                </p>

                                <a
                                    href="https://refassist.com"
                                    target="_system"
                                >
                                    <IonIcon icon={openOutline} />
                                    RefAssist
                                </a>
                            </>
                        ) : (
                            <IonList
                                style={{
                                    marginTop: 20,
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    borderRadius: 5,
                                }}
                                lines="none"
                            >
                                {refAssistSubs.map((sub) => {
                                    return (
                                        <IonItem key={sub.id}>
                                            <IonIcon
                                                color={"primary"}
                                                icon={checkmarkCircleOutline}
                                                slot={"start"}
                                            />
                                            {sub.rawData?.levels?.length > 0 ? (
                                                <ul
                                                    style={{
                                                        paddingLeft: 0,
                                                        listStyle: "none",
                                                    }}
                                                >
                                                    {sub.rawData?.levels?.map(
                                                        (level: any) => (
                                                            <li>
                                                                {level.subLevel}
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            ) : (
                                                <IonText>
                                                    {sub.planDescription}
                                                </IonText>
                                            )}
                                        </IonItem>
                                    );
                                })}
                            </IonList>
                        )}
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default RefAssistIntegration;
